import React from "react";
import "./Header.scss";
import ArrowSvg from "../../../../../prod/images/_arrow.svg?react";
import ArrowLeftSvg from "../../../../../prod/images/_arrow_left_flat.svg?react";
import classNames from "classnames";
import {
  CatalogueHeaderData,
  CatalogueHeaderItemsData,
} from "../../../../api/headerApi.types";

interface ProductCatalogueMegaMenuMobileProps {
  headerModel: CatalogueHeaderData;
  active: boolean;
  selectedMain: CatalogueHeaderItemsData;
  selectedSub: CatalogueHeaderItemsData;
  setSelectedMain: (main: CatalogueHeaderItemsData) => void;
  setSelectedSub: (sub: CatalogueHeaderItemsData) => void;
}

export const ProductCatalogueMegaMenuMobile: React.FC<
  ProductCatalogueMegaMenuMobileProps
> = ({
  headerModel,
  active,
  selectedMain,
  selectedSub,
  setSelectedMain,
  setSelectedSub,
}) => {
  const handleSelectMainClick = (evt, mainNav) => {
    evt.preventDefault();
    setSelectedMain(mainNav);
  };

  const handleSelectSubClick = (evt, subNav) => {
    evt.preventDefault();
    setSelectedSub(subNav);
  };

  return (
    <div
      className={classNames("header-megamenu-mobile", active ? "active" : "")}
    >
      {selectedMain === null && (
        <ul>
          {" "}
          {headerModel?.items?.map((item) => (
            <li
              className="header-megamenu-main-nav-item-mobile"
              onClick={(evt) => handleSelectMainClick(evt, item)}
              key={item.id}
            >
              <h2>{item.linkTitle}</h2>
              <ArrowSvg />
            </li>
          ))}
        </ul>
      )}
      {selectedMain !== null && selectedSub === null && (
        <ul>
          <li
            className="header-megamenu-sub-nav-header-mobile cursor-pointer hover:underline"
            onClick={(evt) => handleSelectMainClick(evt, null)}
          >
            <ArrowLeftSvg className="mr-4" />
            <h2>{selectedMain?.linkTitle}</h2>
          </li>
          {selectedMain?.subItems?.map((item) => (
            <li
              className="header-megamenu-sub-nav-item-mobile cursor-pointer"
              onClick={(evt) => handleSelectSubClick(evt, item)}
              key={item.id}
            >
              <h2>{item.linkTitle}</h2>
              <ArrowSvg />
            </li>
          ))}
        </ul>
      )}
      {selectedSub !== null && (
        <div>
          <div
            onClick={(evt) => handleSelectSubClick(evt, null)}
            className="editorial-block-main-mobile cursor-pointer hover:underline"
          >
            <ArrowLeftSvg className="mr-4" />
            <h2>{selectedSub.linkTitle}</h2>
          </div>
          <ul>
            {selectedSub?.subItems?.map((item) => (
              <li
                className="header-megamenu-sub-nav-item-mobile hover:underline"
                key={item.id}
              >
                <a className="text-xl" href={item.linkUrl}>
                  {item.linkTitle}
                </a>
                <ArrowSvg />
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
